// Card descriptions, recommendation map, and modal copy for The
// Principles add-level flow. Card titles match the canonical names in
// `decisionTypes['The Principles']` (see ./data) so the lookup into
// filterItems is by-label like the Balanced Equation flow.

export const principlesDecisionTypeCards = [
  {
    key: 'revenue-expense',
    title: 'Revenue & Expense Recognition',
    description: [
      { text: 'In this level, students will decide if the business activity impacts profits.' },
    ],
    // Temporarily hidden from the instructor picker; keep the definition for later re-enable.
    hidden: true,
  },
  {
    key: 'assumptions-principles-constraints',
    title: 'Assumptions, Principles, & Constraints',
    description: [
      { text: 'In this level, students will decide which Assumptions, Principles, and/or Constraints are applicable.' },
    ],
  },
];

// No level-specific recommendation by default. Populate this map (e.g.
// { 1: 'revenue-expense' }) if the design later calls out one card as
// recommended at a given level.
export const principlesRecommendedByLevel = {};

export const principlesModalCopy = {
  title: (levelNumber) => `Level ${levelNumber} | Select Decision Type`,
  subtitle: 'In each level, students review a series of business activities and apply accounting principles, assumptions, and constraints to determine its impact.',
  step2Title: (levelNumber) => `Level ${levelNumber} | Select Scenario & Transactions`,
  step2Subtitle: 'Select a scenario and related transactions',
  scenariosColumnHeader: 'Business Scenarios',
  transactionsColumnHeader: 'Transactions',
  changeDecisionTypeButton: 'Change Decision Type',
  saveButton: 'Save',
  recommendedBadge: ['Recommended', 'for this Level'],
  switchScenarioWarningTitle: 'Are you sure?',
  switchScenarioWarningText: 'Selecting a transaction from a different business scenario will override your existing selections. You cannot mix transactions from different business scenarios in one level.',
};

// Card colors per the Principles spec. Inlined into the modal root as
// CSS variables to override the BE defaults defined in
// balancedEquationLevelModal.css. Title text and divider use the BE
// pattern (navy text, divider matching border color).
export const principlesTheme = {
  '--be-card-bg': '#ECF6F7',
  '--be-card-border': '#55B4BC',
  '--be-card-divider': '#55B4BC',
  '--be-card-text': '#2A4169',
};
